import styled from "@emotion/styled";
import React from "react";

import { ColoredIconProps } from "../types";

import allMultiColoredIcons from "./MultiColorIcons";

export const IconWrapper = styled.div<{ color: string | undefined }>(
  ({ color }) => ({
    "> svg": {
      color: color,
      "> path": {
        fill: "currentColor",
      },
      "> g": {
        fill: "currentColor",
      },
    },
  }),
);

export const ColoredIcon: React.FC<ColoredIconProps> = ({
  icon,
  color,
  width,
  height,
  singleColor,
}) => {
  const Icon = allMultiColoredIcons[icon];
  return singleColor ? (
    <IconWrapper color={color}>
      <Icon color={color} width={width} height={height} />
    </IconWrapper>
  ) : (
    <Icon width={width} height={height} />
  );
};
